import { useTranslation } from 'react-i18next';
import { usePublishVenuaPlannerSerie } from '@/api/generated/venua-planner-planning/venua-planner-planning';
import { toast } from '@/shared/ui';
import { openJobDetail } from '@/modules/jobs';

/**
 * Spuštění publikace seriálu jako background jobu. Po úspěchu otevře okno detailu jobu
 * (průběh pak teče přes SSE do jobs store — žádná query invalidace není potřeba).
 * 409 = publikace tohoto seriálu už běží (spuštěná kýmkoliv): toast s akcí „Zobrazit detail"
 * běžícího jobu (`conflictingRunId` z ProblemDetails extensions).
 */
export function usePublishSerie(productId: string, serieId: string) {
  const { t } = useTranslation('venua-planner');

  const mutation = usePublishVenuaPlannerSerie({
    mutation: {
      onSuccess: (response) => {
        openJobDetail(response.jobRunId);
      },
      onError: (error) => {
        const problem = error.response?.data as { conflictingRunId?: string } | undefined;
        const conflictingRunId =
          error.response?.status === 409 ? problem?.conflictingRunId : undefined;
        if (conflictingRunId) {
          toast({
            severity: 'error',
            description: t('publish.conflict'),
            action: {
              label: t('publish.showDetail'),
              onClick: () => openJobDetail(conflictingRunId),
            },
          });
          return;
        }
        toast({ severity: 'error', description: t('publish.error') });
      },
    },
  });

  return {
    publish: () => mutation.mutate({ productId, serieId }),
    isPending: mutation.isPending,
  };
}
